import React, { Component } from 'react';
import Footer from '../Footer/FooterContainer';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import Explanations from '../Explanations/ExplanationsContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import emergencyFundAssumptionsLabelList from './EmergencyFundAssumptions';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';
import { PDFTitle } from '../../PDFRenderer/components/PDFTitle/PDFTitle';

export default class EmergencyFundView extends Component {
  render() {
    const {
      clientId,
      emergencyFundGoal,
      fpId,
      data,
      isPrint,
      chartDataPrint,
      showCalibration,
      isCurrentPlan,
      assumptionsValues,
      selectedSection,
      title,
    } = this.props;

    if (!emergencyFundGoal) {
      return null;
    }

    return (
      <div className="NewFinancialPlan_emergencyfund">
        <PDFTitle title={title} />

        <div
          className={`NewFinancialPlan_header
              ${!showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        {selectedSection === OVERVIEW && (
          <section className="chart">
            <RecommendedTargetAmountChart
              fpId={fpId}
              isCurrentPlan={isCurrentPlan}
              isPrint={isPrint}
              clientId={clientId}
              data={emergencyFundGoal}
              chartDataPrint={chartDataPrint}
            />
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Emergency Fund Goal Assumptions"
              valuesList={assumptionsValues}
              labelList={emergencyFundAssumptionsLabelList}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && <Tasks />}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={emergencyFundGoal.GoalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}
